
import { withCompController } from '@wix/editor-elements-integrations';
import type {
  IWsrTextAreaProps,
  IWsrTextAreaMapperProps,
  IWsrTextAreaControllerProps,
  IWsrTextAreaStateValues,
} from '../../../components/WsrTextArea/WsrTextArea.props';

export default withCompController<
  IWsrTextAreaMapperProps,
  IWsrTextAreaControllerProps,
  IWsrTextAreaProps,
  IWsrTextAreaStateValues
>(({ mapperProps, controllerUtils, stateValues }) => {
  const { editorType } = stateValues
  return {
    ...mapperProps,
    editorType,
    updateComponentPropsInViewer: props => {
      controllerUtils.updateProps(props);
    }
  }
});
